import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { NavLink } from "react-router-dom";
// import styles from './css/Header.css';
import "./css/Header.css";
import { faPaw, faGamepad } from "@fortawesome/free-solid-svg-icons";

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = React.useState(false);
  const [dropdownOpen, setDropdownOpen] = React.useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  return (
    <header className="header os-header">
      <div className="os-header-container">
        <nav className={`os-header-nav ${mobileMenuOpen ? "active" : ""}`}>
          <a href="/" className="os-nav-link">
            Home
          </a>
          <div className={`os-dropdown ${dropdownOpen ? "open" : ""}`}>
            <button
              className="os-nav-link os-dropdown-toggle"
              onClick={toggleDropdown}
            >
              About
            </button>
            <div className="os-dropdown-menu">
              <a href="/about" className="os-dropdown-item">
                Bio
              </a>
              <a href="/pets" className="os-dropdown-item">
                Pets
              </a>
              <a href="/ModelDisplay" className="os-dropdown-item">
                3D Models
              </a>
            </div>
          </div>
          <a href="/projects" className="os-nav-link">
            Projects
          </a>
          <a href="/contact" className="os-nav-link">
            Contact
          </a>
        </nav>
        <button
          className="os-mobile-toggle"
          onClick={toggleMobileMenu}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </header>
  );
};

export default Header;
